/* eslint-disable import/default */

import './sentry';
import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import moment from 'moment';
import { Settings } from 'luxon';
import configureStore from './store/configureStore';
import { syncApiWithStore } from './api/apiBase';
import Root from './components/Root';
import { actions as unitActions } from './actions/unitActions';
import { actions as cmsActions } from './actions/cmsActions';
import { initValidation } from './utils/validate';
import history from './history';

import './styles/styles.scss';
require('./favicon.ico');

Settings.defaultLocale = 'pl';

import es6promise from 'es6-promise';

es6promise.polyfill();

initValidation();
moment.locale('pl');
const store = configureStore();
syncApiWithStore(store);

store.dispatch(unitActions.loadDetails());
store.dispatch(cmsActions.loadDetails());

render(
  <AppContainer>
    <Root store={store} history={history} />
  </AppContainer>,
  document.getElementById('app')
);

if (module.hot) {
  module.hot.accept('./components/Root', () => {
    const NewRoot = require('./components/Root').default;
    render(
      <AppContainer>
        <NewRoot store={store} history={history} />
      </AppContainer>,
      document.getElementById('app')
    );
  });
}



// WEBPACK FOOTER //
// ./src/index.js